import React, { PropTypes } from 'react';
import ImportModal from './ImportModal';

const EstimateModal = ({ caseId, targetId }) => (
  <ImportModal
    modalType="estimate"
    caseId={caseId}
    isAAST={false}
    targetId={targetId}
    title="Import de devis"
    baseUrlForBills="/pco-manager/estimates/bills?caseId="
    baseUrlForBillContent="/pco-manager/estimates/bills/"
  />
);

EstimateModal.propTypes = {
  caseId: PropTypes.number.isRequired,
  targetId: PropTypes.number,
};

export default EstimateModal;



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/imports/components/EstimateModal.js